




































































































import { Vue, Component } from 'vue-property-decorator';
import { default as PageDescribe } from '@/components/PageDescribe.vue';
import { default as DataPanel } from '@/components/DataPanel.vue';
import { default as SearchPanel } from '@/components/SearchPanel.vue';
import { PaginationPanel, DraggerImg } from '@/components';
import collapse from '../../utils/collapse.js';
import ListFilterPanel from '@/components/ListFilterPanel.vue';
import publicFunc from '../../common/util/publicFunc';
import { formRules } from '@/common/util/validator';
import { AppointmentTime, WareHouse } from '@/http';
import { enums } from '@/common/enums';
export interface Pagination {
    skip: number;
    count: number;
    currentPage: number;
}
@Component({
    components: {
        PageDescribe,
        DataPanel,
        PaginationPanel,
        collapse,
        ListFilterPanel,
        SearchPanel,
        DraggerImg,
    },
})
export default class timeWindowSetting extends Vue {
    public searchPagin: Pagination = {
        skip: 0,
        count: 10,
        currentPage: 1,
    };
    public $refs!: {
        pagination: HTMLFormElement;
        multipleTable: HTMLFormElement;
        draggerImg: HTMLFormElement;
    };
    public stateType = enums.storeState;
    public publicFunc: any = publicFunc;
    public formRules = formRules;
    public loading = false;
    public rePagin = false;
    public total = 0;
    public tableData: any = [];
    public labelPosition: string = 'right';
    public searchValue: any = {
        wareHouseName: '',
        isEnabled: '',
        orderBy: '',
        ASC: true,
    };

    public jcsjckb3: boolean = false;
    public created() {
        let webMenus = JSON.parse(localStorage.getItem('mlssloginAd')).webMenus;
        this.jcsjckb3 = webMenus.includes('jcsjckb3');
    }
    public mounted() {
        this.$refs.draggerImg.imgdrager();
        if (sessionStorage.getItem('TimeWindowSetting_searchValue')) {
            this.searchValue = JSON.parse(sessionStorage.getItem('TimeWindowSetting_searchValue'));
            this.searchPagin = sessionStorage.getItem('TimeWindowSetting_page')
                ? JSON.parse(sessionStorage.getItem('TimeWindowSetting_page'))
                : this.searchPagin;
            if (this.$route.query.type === 'time') {
                this.searchFunc();
            } else {
                this.loadData();
            }
        } else {
            this.searchPagin = sessionStorage.getItem('TimeWindowSetting_page')
                ? JSON.parse(sessionStorage.getItem('TimeWindowSetting_page'))
                : this.searchPagin;
            if (this.$route.query.type === 'time') {
                this.searchFunc();
            } else {
                this.loadData();
            }
        }
    }
    public async onPaginationChange(pagin: Pagination) {
        this.searchPagin = pagin;
        sessionStorage.setItem('TimeWindowSetting_page', JSON.stringify(pagin));
        this.loadData();
    }
    public searchFunc() {
        this.loadData();
        sessionStorage.setItem('TimeWindowSetting_searchValue', JSON.stringify(this.searchValue));
        // this.$refs.pagination.handleCurrentChange(1);
        // this.searchPagin.skip = 0;
    }
    public resetSearchValue() {
        this.searchValue = {
            wareHouseName: '',
            isEnabled: '',
            orderBy: '',
            ASC: true,
        };
        // this.$refs.multipleTable.clearSort();
        // this.$refs.pagination.resetSize();
        // this.$refs.pagination.handleSizeChange(10);
        this.searchFunc();
        sessionStorage.setItem('TimeWindowSetting_searchValue', JSON.stringify(this.searchValue));
    }

    public async loadData() {
        this.loading = true;
        try {
            let res = await AppointmentTime.GetTimeWDList({
                ...this.searchValue,
                skip: this.searchPagin.skip,
                count: this.searchPagin.count,
            });
            res.data.forEach((e) => {
                e.startDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(e.startDate);
                e.endDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(e.endDate);
            });
            this.tableData = res.data;
            let skip = this.searchPagin.skip;
            this.$refs.pagination.setPage(this.searchPagin.currentPage);
            this.tableData.map((item, index) => {
                item.index = skip++ + 1;
            });
            this.total = res.total;
            this.loading = false;
            /**无数据返回上一页 */
            if (this.searchPagin.currentPage > 1) {
                if (this.tableData.length == 0) {
                    this.searchPagin.currentPage = this.searchPagin.currentPage - 1;
                    this.$refs.pagination.handleCurrentChange(this.searchPagin.currentPage);
                }
            }
        } catch {
            this.loading = false;
        }
    }
    public add() {
        this.$router.push({
            path: '/timeWindowEdit',
            query: {
                pageTitle: '新增时间窗口',
            },
        });
    }
    public edit(row) {
        this.$router.push({
            path: '/timeWindowEdit',
            query: {
                pageTitle: '编辑时间窗口',
                id: row,
            },
        });
    }

    public selectionRow = [] as any;

    handleSelectionChange(rows) {
        this.selectionRow = rows; //保存已选择行
    }
    rowStyle({ row, rowIndex }) {
        Object.defineProperty(row, 'rowIndex', {
            value: rowIndex,
            writable: true,
            enumerable: false,
        });
    }

    rowClick(row) {
        let refsElTable = this.$refs.multipleTable as any; // 获取表格对象
        let findRow = this.selectionRow.find((c) => c.rowIndex == row.rowIndex);
        if (findRow) {
            refsElTable.toggleRowSelection(row, false);
            return;
        }
        refsElTable.clearSelection();
        refsElTable.toggleRowSelection(row); // 调用选中行方法
    }

    selectable(row, rowIndex) {
        //多选框不可勾选
        if (this.selectionRow.find((c) => c.rowIndex === row.rowIndex)) {
            return true;
        } else {
            return false;
        }
    }
}
